module.exports = __webpack_public_path__ + "img/banner.33d07a50.jpg";